module.exports = __webpack_public_path__ + "static/img/21.f5a39fcc.png";